import { Lightbulb, Info } from "lucide-react";

/**
 * R8 / v0.5.0 — IpotesiSoftwareCard
 *
 * Riassume sopra la VociGrid le ipotesi che il software ha applicato
 * automaticamente (fluido di progetto rilevato, motivazione) in modo
 * che l'operatore possa vedere a colpo d'occhio perché le celle sono
 * AZZURRE (default_software).
 *
 * Prende la prima voce del payload (heuristic: tutti condividono lo
 * stesso fluido detectato dal testo o dal settore). Non renderizza se
 * non c'è fluido rilevato.
 */
export default function IpotesiSoftwareCard({ voci, settore }) {
  if (!voci || voci.length === 0) return null;
  const first = voci[0];
  const fluidoId = first._fluido_rilevato;
  const fluidoLabel = first._fluido_label || fluidoId;
  const fluidoMotiv = first._fluido_motivazione;
  const totalBlueCells = voci.reduce(
    (acc, v) => acc + Object.keys(v.parametri_inferiti || {}).length,
    0
  );
  const totalGreenCells = voci.reduce(
    (acc, v) => acc + Object.keys(v.parametri_estratti || {}).length,
    0
  );
  const totalRedCells = voci.reduce(
    (acc, v) => acc + (v.parametri_mancanti_critici || []).length,
    0
  );

  if (!fluidoId && !settore) return null;

  return (
    <div
      className="rounded-lg px-4 py-3 mb-3 flex items-start gap-3"
      style={{
        background: "var(--semantic-blue-bg)",
        border: "1px solid var(--semantic-blue)",
        color: "#075985",
      }}
      data-testid="ipotesi-software-card"
    >
      <Lightbulb
        className="h-4 w-4 mt-0.5 shrink-0"
        style={{ color: "var(--semantic-blue)" }}
      />
      <div className="flex-1 min-w-0">
        <div className="text-[12px] font-semibold mb-0.5">
          Ipotesi software applicate
        </div>
        <div className="text-[12px] leading-relaxed">
          {settore && (
            <span data-testid="ipotesi-settore">
              Settore:&nbsp;
              <strong className="font-semibold">{settore}</strong>
              {fluidoLabel && " · "}
            </span>
          )}
          {fluidoLabel && (
            <span data-testid="ipotesi-fluido">
              Fluido default:&nbsp;
              <strong className="font-semibold">{fluidoLabel}</strong>
            </span>
          )}
          {fluidoMotiv && (
            <div
              className="text-[11px] mt-1 italic"
              style={{ color: "#0C4A6E" }}
              data-testid="ipotesi-motivazione"
            >
              {fluidoMotiv}
            </div>
          )}
        </div>
        <div
          className="mt-2 flex items-center gap-3 text-[11px]"
          style={{ color: "#0C4A6E" }}
        >
          <span className="inline-flex items-center gap-1">
            <span
              className="inline-block w-2 h-2 rounded-full"
              style={{ background: "var(--semantic-green)" }}
            />
            {totalGreenCells} da cliente
          </span>
          <span className="inline-flex items-center gap-1">
            <span
              className="inline-block w-2 h-2 rounded-full"
              style={{ background: "var(--semantic-blue)" }}
            />
            {totalBlueCells} default software
          </span>
          {totalRedCells > 0 && (
            <span className="inline-flex items-center gap-1">
              <span
                className="inline-block w-2 h-2 rounded-full"
                style={{ background: "var(--semantic-red)" }}
              />
              {totalRedCells} da chiedere
            </span>
          )}
        </div>
      </div>
      <Info
        className="h-3.5 w-3.5 mt-0.5 shrink-0 opacity-60"
        aria-label="I valori azzurri sono proposte. Puoi modificarli cliccando sulla cella."
      />
    </div>
  );
}
